import { render, staticRenderFns } from "./TkSkeletonLoader.vue?vue&type=template&id=5dec4e14&"
import script from "./TkSkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./TkSkeletonLoader.vue?vue&type=script&lang=js&"
import style0 from "./TkSkeletonLoader.vue?vue&type=style&index=0&id=5dec4e14&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports